export default class EmptyFileError extends Error {
  constructor(filePath) {
    super('file is empty: ' + filePath); // (1)
    this.name = 'EmptyFileError'; // (2)
  }
}
